// removed by extract-text-webpack-plugin
module.exports = {"question":"theme__question___1Brv0","questionTitle":"theme__questionTitle___1-Mro","fadeUp":"theme__fadeUp___su48C","claims":"theme__claims___3YFc0","lateFadeUp":"theme__lateFadeUp___1b_-O","lateFadeIn":"theme__lateFadeIn___1yWeO"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/Question/theme.scss
// module id = 1297
// module chunks = 0